import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { CandidateDetail } from '@/features/candidate-detail'

const candidateDetailSearchSchema = z.object({
  tab: z.enum(['overview', 'linkdapi', 'weekday', 'resume', 'lemlist']).optional(),
  view: z.enum(['details', 'prompt']).optional(),
})

export type CandidateDetailSearchParams = z.infer<
  typeof candidateDetailSearchSchema
>

export const Route = createFileRoute('/_authenticated/candidates/$uid/')({
  validateSearch: candidateDetailSearchSchema,
  component: CandidateDetail,
})
